import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
interface Instructor {
  name: string;
  role: string;
  image: string;
}
export function InstructorsPage() {
  const instructors: Instructor[] = [{
    name: 'Master Mark Kanaar',
    role: 'Owner / Instructor',
    image: 'https://static.wixstatic.com/media/a09ac0_2de382b388f54533893cf9a7f204b6e4~mv2.jpg'
  }, {
    name: 'Master Daniel Foster',
    role: 'Bridgeport Instructor · Tang Soo Do Master',
    image: 'https://static.wixstatic.com/media/fcd869_3b809ebd4a3742aa8171ba6d0ebccdd1~mv2.png'
  }, {
    name: 'Deb Foutch',
    role: 'Bridgeport / Caro Instructor',
    image: 'https://static.wixstatic.com/media/fcd869_24216ad361aa46d98418833b874c6011~mv2.jpg'
  }, {
    name: 'Matt Foutch',
    role: 'Bridgeport / Caro Instructor',
    image: 'https://cdn.magicpatterns.com/uploads/ibyookAeVg54U9oQtkaL3K/Matt.jpg'
  }, {
    name: 'Troy Foutch',
    role: 'Bridgeport / Caro Instructor',
    image: 'https://static.wixstatic.com/media/fcd869_6fb39f864aa54529a41e75773bb7be1d~mv2.jpg'
  }, {
    name: 'Anna Garcia',
    role: 'Bridgeport / Caro Instructor',
    image: 'https://static.wixstatic.com/media/fcd869_8881ad623ae5468d994434b155b36813~mv2.jpg'
  }, {
    name: 'Chad Kilbourn',
    role: 'Midland Instructor',
    image: 'https://static.wixstatic.com/media/fcd869_fef2144520cb47158903bf1766541371~mv2.jpg'
  }, {
    name: 'Roxy Kilbourn',
    role: 'Midland Instructor',
    image: 'https://static.wixstatic.com/media/fcd869_72a6286ad5504735a7ab58368cb2c6a7~mv2.jpg'
  }, {
    name: 'Master Eric Reynolds',
    role: 'Midland Instructor',
    image: 'https://static.wixstatic.com/media/fcd869_e23061be7618436690f5ef3820ccaa2c~mv2.jpg'
  }, {
    name: 'Joey Skutt',
    role: 'Midland Instructor',
    image: 'https://static.wixstatic.com/media/fcd869_b684b6fb5ea5492eb14fd61440baade3~mv2.jpg'
  }, {
    name: 'Alec Strickland',
    role: 'Bridgeport Instructor',
    image: 'https://static.wixstatic.com/media/a09ac0_727ce1b3973b4e6ca9a8d74369636bce~mv2.jpg'
  }, {
    name: 'Bob Wegner',
    role: 'Instructor',
    image: 'https://static.wixstatic.com/media/fcd869_71172868f156450b846071840e1f2aa0~mv2.jpg'
  }, {
    name: 'Lucas Chaddah',
    role: 'Bridgeport Instructor',
    image: 'https://static.wixstatic.com/media/a09ac0_2ebb4f47804b4d8382c5831e49a6739b~mv2.jpg'
  }, {
    name: 'Joy Von Matt',
    role: 'Midland Instructor / Aerobics',
    image: 'https://static.wixstatic.com/media/a88700_02c3331882224bc1a65f167b4b23a6b2~mv2.jpg'
  }, {
    name: 'Audrey Martin',
    role: 'Midland Instructor',
    image: 'https://static.wixstatic.com/media/a88700_39c82ccceccf4f0aa37a7864f0cf6726~mv2.jpeg'
  }];
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-902">
      <Header data-id="element-903" />

      <main className="pt-20" data-id="element-904">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-905">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-906">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-907">
              Our Instructors
            </h1>
            <p className="text-lg text-slate-200 max-w-3xl" data-id="element-908">
              Meet the dedicated team of martial arts professionals who guide
              students at Che Ko Martial Arts. Our instructors bring years of
              experience, passion, and commitment to helping every student reach
              their full potential.
            </p>
          </div>
        </section>

        {/* Instructors Grid */}
        <section className="py-16 bg-white" data-id="element-909">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-910">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-911">
              {instructors.map((instructor, index) => <div key={index} className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-sm" data-id="element-912">
                  <div className="aspect-[3/4] bg-slate-100" data-id="element-913">
                    <img src={instructor.image} alt={instructor.name} className={`w-full h-full object-cover ${instructor.name === 'Matt Foutch' ? 'object-top' : ''}`} data-id="element-914" />
                  </div>
                  <div className="p-4 text-center" data-id="element-915">
                    <h3 className="text-lg font-bold text-[#1a2332] mb-1" data-id="element-916">
                      {instructor.name}
                    </h3>
                    <p className="text-sm text-slate-600" data-id="element-917">{instructor.role}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-918" />
    </div>;
}